import { SearchState } from '../../models';
import { DEFAULT_SORT } from './search.const';

export function getInitialSearchState(): SearchState {
  return {
    banners: [],
    directs: [],
    facets: {},
    facetsGroups: {},
    keepPreviousResults: false,
    loading: false,
    numFound: 0,
    page: 1,
    partialResults: [],
    preSelectedFilters: {},
    promoteds: [],
    query: '',
    queryTagging: {
      url: '',
      params: {}
    },
    results: [],
    sort: DEFAULT_SORT,
    spellcheck: ''
  };
}
